/**
 * a generic function to capitalize strings
 * @param {string} string what must be capitalized
 */
const Capitalize = (string) => {
    if(!string) return "";
    return string.replace(/^\w/, c => c.toUpperCase()).replaceAll("google", "Google");
}

export default Capitalize;